export default "__VITE_ASSET__h_w5sroO__"